import { MobXProviderContext } from 'mobx-react'
import { IValueMap } from 'mobx-react/dist/types/IValueMap'
import React, { Context } from 'react'
import { ChilizStore } from './ChilizStore'
import { ChilizConfigProvider } from '../config/configProvider'

const currentEnvironment = (process.env.REACT_APP_ENVIRONMENT as string).length > 0 ? (process.env.REACT_APP_ENVIRONMENT as string) : 'devnet'

console.log(`Current env is: ${currentEnvironment}`)

const config: ChilizConfigProvider = new ChilizConfigProvider()
const chilizStore = new ChilizStore(config)

void chilizStore.connectFromInjected().then(async () => {
  const currentAccount = chilizStore.getKeyProvider().currentAccount()
  console.log(`Current account is: ${currentAccount}`)
})

export const useChilizStore = (): ChilizStore => chilizStore
export const useChilizConfigProvider = (): ChilizConfigProvider => config

interface IAppContext {
  store: ChilizStore
  configProvider: ChilizConfigProvider
}

const context: IAppContext = {
  store: useChilizStore(),
  configProvider: useChilizConfigProvider()
}
export const AppContext = React.createContext(context)

export const useStores = (): IAppContext => {
  return React.useContext(AppContext)
}
